<!-- Test resizable panels
 <div class="mbox">
 <app-navbar class="mrow mheader"></app-navbar>
 <app-splitter class="mrow mcontent" direction="horizontal" [initial]="300">

  <div first>
    LEFT PANEL
  </div>

  <div second>
    <app-splitter direction="vertical" [initial]="600">

      <div first>
        RIGHT TOP
      </div>

      <div second>
        RIGHT BOTTOM
      </div>

    </app-splitter>
  </div>

</app-splitter>
</div>
-->


<div class="mbox">
    <app-navbar class="mrow mheader"></app-navbar>

    <div role="main" class="mrow mcontent">
        <router-outlet></router-outlet>
    </div>
</div>

